import { put, select } from "redux-saga/effects";
import {
  ConnectionResultEnum,
  InvalidEnum,
  PaymentSessionToken,
} from "redmond";
import { Payment } from "@b2bportal/purchase-api";
import { getHSPEarnOfferDescription, isEarnOfferV2, isSpendAndGetOffer } from "halifax";
import { getIsTravelApp, getUserDeviceData } from "@capone/common";
import { actions } from "../../actions";
import schedulePayment from "../../../../api/v0/book/book-flow/schedulePayment";
import { ProductFunnelHeader } from "../../../../api/v0/book/book-flow/productFunnel";
import { getOffers, getOpaquePayments, getSession, getTripDescription } from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import { authorizeEarnOffer } from "../../../../api/v0/travel-wallet/authorizeEarnOffer";

export function* scheduleBookSaga({
  agentFee,
  isRecommended,
  ancillaries,
  initialTime,
}: actions.ISetScheduleBook) {
  try {
    const state: IStoreState = yield select();
    const session = getSession(state);
    if (!session) {
      throw Error("Session is undefined");
    }
    const payments = getOpaquePayments(state);
    if (!payments) {
      throw new Error("Invalid Request.");
    }

    const offers = getOffers(state);
    const appliedOfferPayment = payments.find(
      (payment) => payment.type === Payment.TravelWalletOffer
    );

    const appliedOffer = offers?.find(
      (offer) => offer.id === appliedOfferPayment?.value.offerId
    );

    const hspEarnDescription = getHSPEarnOfferDescription(appliedOffer);
    const isV2EarnOffer = isEarnOfferV2(appliedOffer);
    const isSpendAndGet =
      appliedOffer && isSpendAndGetOffer(appliedOffer.descriptions);

    // authorize hsp earn offer before fulfillment (not for spend-and-get offers or v2 earn offers)
    if (hspEarnDescription && !isV2EarnOffer && appliedOffer?.id) {
      yield authorizeEarnOffer({
        earnOfferId: appliedOffer.id,
      });
    }

    const corporateOutOfPolicyReason =
      state.premierCollectionBook.approvalRequestReason;
    const corporateTripDescription = getTripDescription(state);

    const { isTravelApp } = getIsTravelApp();

    const userDeviceData = getUserDeviceData();

    const channel = (() => {
      switch (true) {
        case isTravelApp:
          return "TravelApp";
        case userDeviceData.deviceType === "mobile":
          return "Mobile";
        default:
          return "Web";
      }
    })();

    // Don't include legacy HSP earn offers or spend-and-get offers in payments.
    // v2 earn offers are sent as regular payments.
    const shouldFilterOffer =
      (hspEarnDescription && !isV2EarnOffer) || isSpendAndGet;

    const result: string = yield schedulePayment(
      session,
      shouldFilterOffer
        ? payments.filter(
            (payment) => payment.type !== Payment.TravelWalletOffer
          )
        : payments,
      ancillaries,
      channel,
      corporateOutOfPolicyReason,
      corporateTripDescription,
      ProductFunnelHeader.Hotels
    );

    // update the session to the fulfill session token
    yield put(actions.setSession({ value: result } as PaymentSessionToken));
    yield put(
      actions.pollConfirmationDetails(
        session!,
        agentFee,
        isRecommended,
        initialTime
      )
    );
    yield put(actions.setScheduleBookSuccess());
  } catch (e) {
    yield put(
      actions.setScheduleBookFailed({
        Invalid: InvalidEnum.Missing,
        ConnectionResult: ConnectionResultEnum.Invalid,
      })
    );
  }
}
